import { BuyUpsellBody } from 'publisher/api/paypalRestApi'
import { useManagement, usePage, usePayment } from 'publisher/store'
import managementSelectors from 'publisher/store/management/managementSelectors'
import pageSelectors from 'publisher/store/page/pageSelectors'
import {
  default as paymentSelectors,
  default as typedPaymentSelectors,
} from 'publisher/store/payment/paymentSelectors'
import { useState } from 'react'
import { UpsellButtonEntityInterface } from 'src/shared/entities/upsell-button/upsell-button.schema'

export default function useUpsellSubmit(entity: UpsellButtonEntityInterface) {
  const [isLoading, setLoading] = useState(false)
  const [errors, setErrors] = useState<string[]>([])
  const checkedPricePlanId = usePayment(paymentSelectors.getCheckedPricePlanId)
  const pageId = usePage(pageSelectors.getPageId)
  const purchaseProcessId = usePayment(paymentSelectors.getPurchaseProcessId)
  const isDesktop = useManagement(managementSelectors.isDesktop)
  const popupId = usePage(p => pageSelectors.getAscendantPopupId(p, entity))

  const mandatoryCheckboxes = usePage(p =>
    pageSelectors.getVisibleMandatoryCheckboxes(p, isDesktop, popupId),
  )
  const confirmedCheckboxesIds = useManagement(
    managementSelectors.getConfirmedCheckboxesIds,
  )
  const product = usePayment(typedPaymentSelectors.getProduct)
  const productQuantity = usePayment(typedPaymentSelectors.getProductQuantity)
  const activeProductVariant = usePayment(
    typedPaymentSelectors.getProductActiveVariant,
  )

  const submit = async (paymentMethodHandler: any) => {
    setErrors([])

    const checkboxesErrors = mandatoryCheckboxes.reduce(
      (errors: string[], checkbox) => {
        if (confirmedCheckboxesIds.includes(checkbox.id)) {
          return errors
        }
        errors.push(
          'options' in checkbox
            ? checkbox.options.errorText
            : checkbox.errorText,
        )
        return errors
      },
      [],
    )

    if (checkboxesErrors.length > 0) {
      setErrors(checkboxesErrors)
      return
    }

    const calculatedFormProperties: BuyUpsellBody = product
      ? {
          product: {
            id: product?.id,
            variant: activeProductVariant?.id,
            quantity: productQuantity,
          },
          checkboxIds: confirmedCheckboxesIds,
        }
      : {
          offerPricePlan: checkedPricePlanId,
          agree: true,
          checkboxIds: confirmedCheckboxesIds,
        }

    setLoading(true)

    try {
      return await paymentMethodHandler(
        calculatedFormProperties,
        pageId,
        purchaseProcessId,
      )
    } finally {
      setLoading(false)
    }
  }

  return { errors, setErrors, isLoading, submit }
}
